import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  clearAclDetails,
  clearAclLoadingStatuses,
  clearAclCompleted,
  getAclDetails,
  getMainAclDetails,
  setMultiLoadingStatus,
  setActionCompleted,
} from '@redux/modules/acl';

import {
  getCompleted,
  getFieldPermissions,
  getFormActions,
  getAclString,
  getIsAdmin,
  getFormPermissions,
  getMainActions,
  getPagePermissions,
  getError,
  getMultiLoading,
} from '@redux/selectors/AclSelector';

const useAcl = () => {
  const dispatch = useDispatch();
  const fieldPermissions = useSelector(getFieldPermissions);
  const formActions = useSelector(getFormActions);
  const aclString = useSelector(getAclString);
  const isAdmin = useSelector(getIsAdmin);
  const formPermissions = useSelector(getFormPermissions);
  const mainActions = useSelector(getMainActions);
  const pagePermissions = useSelector(getPagePermissions);
  const isAclError = useSelector(getError);

  const isMultiLoading = useSelector(getMultiLoading);
  const isAclCompleted = useSelector(getCompleted);
  const [aclInitialized, setAclInitialized] = useState(true);

  const getListingAcl = requestDetails => {
    dispatch(getAclDetails('listing', requestDetails));
  };

  const getAgentAcl = requestDetails => {
    const actionName = `${requestDetails.formname}${requestDetails.action}`;
    const loadingStatus = { [actionName]: true };
    const completeStatus = { [actionName]: false };
    dispatch(getAclDetails('agentACL', requestDetails));
    dispatch(setMultiLoadingStatus(loadingStatus));
    dispatch(setActionCompleted(completeStatus));
  };

  const getOfficeAcl = requestDetails => {
    dispatch(getAclDetails('officeACL', requestDetails));
  };

  const getMainAcl = requestDetails => {
    dispatch(getMainAclDetails('mainACL', requestDetails));
  };

  const clearAcl = () => {
    dispatch(clearAclDetails());
  };

  const clearMultiStatus = () => {
    dispatch(clearAclLoadingStatuses());
  };

  const clearAclCompletedLog = () => {
    dispatch(clearAclCompleted());
  };

  const isLoadingMultiple = () => {
    const loadingStatus = isMultiLoading;
    const loadingValues = Object.values(loadingStatus);
    const isLoadingTrueFound = loadingValues.includes(true);
    return isLoadingTrueFound;
  };

  const isAllComplete = () => {
    const completeCalls = isAclCompleted;
    if (Object.keys(completeCalls).length === 0) return false;
    const completeStatus = !(Object.values(completeCalls).includes(false));
    return completeStatus;
  };

  /* Clear ACL details on un-mount. */
  useEffect(() => {
    clearAcl();
    clearAclCompleted();
    clearMultiStatus();
  }, []);

  useEffect(() => {
    setAclInitialized(true);
  }, []);

  return {
    aclInitialized,
    canEditForm: formActions?.EDIT ?? false,
    canCopyForm: formActions?.COPY ?? false, // listings only
    canAuditForm: formActions?.AUDITLOG ?? false, // listings only
    canViewForm: formActions?.VIEW ?? false,
    canViewTeam: formActions?.VIEWTEAM ?? false, // agents only
    canEditTeam: formActions?.EDITTEAM ?? false, // agents only
    canAddTeamMember: formActions?.ADDTEAMMEMBER ?? false, // agents only
    canAddToTeam: formActions?.ADDTOTEAM ?? false, // agents only
    fieldPermissions,
    formActions,
    aclString,
    formPermissions,
    mainActions, // homepage only
    pagePermissions,
    isAdmin,
    isAclError,
    isAllComplete,
    isLoadingMultiple,
    clearMultiStatus,
    clearAclCompletedLog,
    getListingAcl,
    getAgentAcl,
    getOfficeAcl,
    getMainAcl,
  };
};

export default useAcl;
